import { Component } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { InteractiveLoginService } from '@app/services/interactive-login/interactive-login.service';

@Component({
	selector: 'app-modal-showcase',
	templateUrl: './modal-showcase.component.html'
})
export class ModalShowcaseComponent {
	modalVisible = false;
	modalAlertVisible = false;
	
	public forceCurrentUser = true;

	constructor(
		private modal: NzModalService,
		private readonly loginService:InteractiveLoginService) {}
	
	public async login():Promise<void>{
		const result = await this.loginService.promptLogin(this.forceCurrentUser);
		
		alert(JSON.stringify(result));
	}

	public showModal(): void {
		this.modalVisible = true;
	}

	public handleOk(): void {
		console.log('Clicked OK');
		this.modalVisible = false;
	}

	public handleCancel(): void {
		console.log('Clicked Cancel');
		this.modalVisible = false;
	}

	public showAlertModal(): void {
		this.modalAlertVisible = true;
	}

	public handleAlertOk(): void {
		console.log('Clicked OK');
		this.modalAlertVisible = false;
	}

	public handleAlertCancel(): void {
		console.log('Clicked Cancel');
		this.modalAlertVisible = false;
	}

	info(): void {
		this.modal.info({
			nzTitle: 'This is a notification message',
			nzContent: '<p>Nachrichten...Nachrichten...</p><p>Nachrichten...Nachrichten...</p>',
			nzOnOk: () => console.log('Info OK')
		});
	}

	success(): void {
		this.modal.success({
			nzTitle: 'This is a success message',
			nzContent: 'Nachrichten...Nachrichten...'
		});
	}

	error(): void {
		this.modal.error({
			nzTitle: 'This is an error message',
			nzContent: 'Nachrichten...Nachrichten...'
		});
	}

	warning(): void {
		this.modal.warning({
			nzTitle: 'This is an warning message',
			nzContent: 'Nachrichten...Nachrichten...'
		});
	}

	createCustomButtonModal(): void {
		const modal: NzModalRef = this.modal.create({
			nzTitle: 'custom button demo',
			nzContent: 'Eine Liste von Buttons mit verschiedenen Funktionen sind hier nun Teil des Footer',
			nzMaskClosable: false,
			nzFooter: [
				{
					label: 'Close',
					shape: 'round',
					onClick: () => modal.destroy()
				},
				{
					label: 'Confirm',
					type: 'primary',
					onClick: () => this.modal.confirm({nzTitle: 'Confirm Modal Title', nzContent: 'Confirm Modal Content'})
				},
				{
					label: 'Change Button Status',
					type: 'primary',
					danger: true,
					loading: false,
					onClick(): void {
						this.loading = true;
						setTimeout(() => (this.loading = false), 1000);
						setTimeout(() => {
							this.loading = false;
							this.disabled = true;
							this.label = 'can not be clicked！';
						}, 2000);
					}
				},
				{
					label: 'async load',
					type: 'dashed',
					onClick: () => new Promise(resolve => setTimeout(resolve, 2000))
				}
			]
		});
	}
}
